import Utils from "@/utils/utils"

const inactivityThreshold = Utils.minutes(3)

export { inactivityThreshold }
